import _ from 'underscore';
import { targetOptions } from '@bingads-webui-campaign-react/location-targeting';

const ERROR_MAP = {
  LOCATION_CONFLICT: {
    type: 'LOCATION_CONFLICT',
    errorString: _TL_('There are conflicts between your included and excluded locations. '),
  },
  NO_INTENT_SELECTED: {
    type: 'NO_INTENT_SELECTED',
    errorString: _TL_('Please select at least one intent. '),
  },
  EMPTY_LOCATION: {
    type: 'EMPTY_LOCATION',
    errorString: _TL_('Please select at least one location. '),
  },
};

export const validateConflictLocations = (includedLocations, excludedLocations) => {
  let exclusiveIds = [];
  _.forEach(includedLocations, (locationTarget) => {
    const parentIds = _.pluck(locationTarget.ParentLocations, 'Id');
    exclusiveIds.push(locationTarget.LocationId, ...parentIds);
  });
  // TODO: Check if we need to remove duplicates, for example, targeting "new york" and "US" will cause duplication.
  exclusiveIds = _.uniq(exclusiveIds);

  const negativeIds = _.uniq(_.map(excludedLocations, locationTarget => locationTarget.LocationId));

  // exclusiveIds can't be shown in negativeIds
  if (_.union(exclusiveIds, negativeIds).length < exclusiveIds.length + negativeIds.length) {
    return ERROR_MAP.LOCATION_CONFLICT;
  }

  return false;
};

export const validateIntent = (peopleInLocation, peopleSearchingForLocation) => {
  if (!peopleInLocation && !peopleSearchingForLocation) {
    return ERROR_MAP.NO_INTENT_SELECTED;
  }

  return false;
};

/**
 * Validate location targeting.
 * 1. Targeted locations can't be shown in excluded locations.
 * 2. At least one intent should be selected.
 * 3. At least one location should be selected.
 * @param {object} targets location targeting data
 * @returns {string} validation result
 */
export const validateLocations = ({
  negativeLocationTargets,
  positiveLocationTargets,
  isPeopleInLocationChecked,
  isPeopleSearchingForLocationChecked,
  selectedLocationOption,
} = {}) => {
  const conflictError = validateConflictLocations(positiveLocationTargets, negativeLocationTargets);
  if (conflictError) {
    return conflictError.errorString;
  }

  const intentError = validateIntent(isPeopleInLocationChecked, isPeopleSearchingForLocationChecked);
  if (intentError) {
    return intentError.errorString;
  }

  if (
    selectedLocationOption === targetOptions.specific
    && _.isEmpty(negativeLocationTargets)
    && _.isEmpty(positiveLocationTargets)
  ) {
    return ERROR_MAP.EMPTY_LOCATION.errorString;
  }

  return '';
};
